import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getDocumentoId,
  documentoPut,
} from "../../../redux/documentos/documentosAction";
import ClienteMod from "./clienteMod";
import ArticulosMod from "./articulosMod";
export default function DocumentoMod() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const documentoId = useSelector((state) => state.documentos.documentoId);
  const [clienteUpdate, setClienteUpdate] = useState();
  const [articulosUpdate, setArticulosUpdate] = useState(documentoId?.articulos || []);
  // const [articuloData, setArticuloData] = useState([
    //     {codArticulo: "", nombre:"", ciclo:"", isbn:"", cantidad:"", precio:"", precioTotal:""}
    // ])
    const [subTotal, setSubTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [cantidadArt, setCantidadArt] = useState(0);
    const [artRepetido, setArtRepetido] = useState(false);    
    const [clienteError, setClienteError] = useState(false);
    const [articuloError, setArticuloError] = useState(false);
    const [verPDF, setVerPDF] = useState(false);
    
    useEffect(() => {
        dispatch(getDocumentoId(id));        
    }, [dispatch]);
    console.log(documentoId);

    useEffect(() => {
        if(documentoId !== undefined){
            setArticulosUpdate(documentoId.articulos)
          }
    }, [documentoId]);

  const handleCliente = (data) => {
    setClienteUpdate(data);
  };
  //console.log(clienteUpdate);

  useEffect(() => {
    sumaSubtotal();
    handleTotal();
  }, [articulosUpdate, subTotal]);

  useEffect(() => {
    nuevoInput();
  }, [articulosUpdate]);

  useEffect(() => {
    handleCantidadArt();
  }, [articulosUpdate]);

  const handleArticuloChange = (index, updatedArticulo) => {
    console.log("index", index);
    console.log("update", updatedArticulo.id);
    console.log(articulosUpdate);
    
    if(updatedArticulo != undefined){
    const articuloRepeat = articulosUpdate.find(
      (e, i) => console.log(e.id, "****", updatedArticulo.id ) //&& i != index   
    );
    console.log("articuloRepeat", articuloRepeat);
    if (articuloRepeat) {
      setArtRepetido(true);
      return;
    }
  }
    
    const newArticulos = [...articulosUpdate];
    newArticulos[index] = updatedArticulo; 
    setArticulosUpdate(newArticulos);    
  };

  const nuevoInput = () => {
    //console.log("checkAndAddNewArticulo");

    const lastArticulo = articulosUpdate && articulosUpdate[articulosUpdate.length - 1];
    //console.log("lastArticulo", lastArticulo);

    if (lastArticulo && lastArticulo.codArticulo && articulosUpdate.length < 30) {
      //console.log("entra al IF");

      setArticulosUpdate([
        ...articulosUpdate,
        {
          codArticulo: "",
          nombre: "",
          ciclo: "",
          isbn: "",
          cantidad: "",
          precio: "",
          precioTotal: "",
        },
      ]);
    }
  };

  const deleteArticulo = (articulo) => {
    if (articulosUpdate.length > 1) {
      const newArticulos = articulosUpdate.filter((e) => e.id !== articulo);
      setArticulosUpdate(newArticulos);
    }
  };

  const sumaSubtotal = () => {
    const subTotal = articulosUpdate &&articulosUpdate.reduce(
      (acc, articulo) => acc + (parseFloat(articulo.precioTotal) || 0),
      0
    );
    //console.log(subTotal);

    setSubTotal(subTotal);
  };

  const handleTotal = () => {
    const descuento = (subTotal * 20) / 100;
    const total = subTotal - descuento;
    setTotal(total);
  };

  const handleCantidadArt = () => {
    const cantidadArt = articulosUpdate && articulosUpdate.reduce(
      (acc, articulo) => acc + (parseFloat(articulo.cantidad) || 0),
      0
    );
    setCantidadArt(cantidadArt);
  };

  const handleSubmit = () => {
    const filteredArticulos =   articulosUpdate.length < 30 ?  articulosUpdate.slice(0, -1) : articulosUpdate //Cortamos y eliminamos el ultimo objeto vacio
    
    if (
      clienteUpdate.nombre === "" ||
      clienteUpdate.ciudad === "" ||
      clienteUpdate.direccion === "" ||
      clienteUpdate.zona === "" ||
      clienteUpdate.telefono === ""
    ) {
      setClienteError(true);
      return;
    } else if (
      articulosUpdate.length === 1 &&
      articulosUpdate[0].codArticulo === ""
    ) {
      setArticuloError(true);
      return;
    }

    dispatch(
      documentoPut(id, {        
        cliente: clienteUpdate,
        articulos: filteredArticulos,
        totalArt: cantidadArt,
        subtotal: subTotal,
        total: total,
      })
    );

    setClienteUpdate({});
    setArticulosUpdate([
      {
        codArticulo: "",
        nombre: "",
        ciclo: "",
        isbn: "",
        cantidad: "",
        precio: "",
        precioTotal: "",
      },
    ]);
    setSubTotal(0);
    setTotal(0);
    setCantidadArt(0);
    //clienteInputRef.current.resetCliente();
    navigate(`/documentoDetalle/${id}`)
  };

  return (
    <>
      <div className="bg-custom container-custom">
        <div className="container m-8 text-orange-500 text-[10pt] font-bold">
          <p>DOCUMENTO A MODIFICAR</p>
          <p>Doc. Numero: {documentoId && documentoId.numDocumento}</p>
          <div className="mt-5" key={documentoId._id}>
            <ClienteMod
              //key={documentoId._id}
              cliente={documentoId.cliente && documentoId.cliente}
              onHandleCliente={handleCliente}
            />
          </div>
          <div className="w-[1180px] mt-3 border text-[10pt] font-bold">
            <table>
              <thead>
                <tr>
                  <td className="w-[80px] text-center border">Cod. Art</td>
                  <td className="w-[600px] pl-2 border">Articulo</td>
                  <td className="w-[120px] text-center border">Ciclo</td>
                  <td className="w-[135px] text-center border">ISBN</td>
                  <td className="w-[80px] text-center border">Cantidad</td>
                  <td className="w-[80px] text-center border">Precio Unit.</td>
                  <td className="w-[80px] text-center border">Precio Total</td>
                </tr>
              </thead>
            </table>
          </div>
          {articulosUpdate && articulosUpdate.length > 0 ? (
            articulosUpdate.map((articulo, index) => {
              return (
                <div className="flex" key={articulo.id}>
                  <ArticulosMod                    
                    index={index}
                    articuloIn={articulo}
                    onArticuloChange={(updatedArticulo) =>
                      handleArticuloChange(index, updatedArticulo)
                    }
                    onDelete={() => deleteArticulo(articulo.id)}
                  />                 
                </div>
              );
            })
        ) : (<p>No hay artículos disponibles.</p>) }
          <div className="font-semibold">
            <p>Cantidad de Articulos: {cantidadArt}</p>
            <p>Subtotal: {subTotal}</p>
            <p>Descuento: 20%</p>
            <p>Total: {total}</p>
          </div>
        </div>
        <div className="flex">
          <button
            className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-sky-400 hover:bg-sky-100 hover:text-gray-400"
            onClick={handleSubmit}
          >
            Guardar
          </button>
          {/* <button
            className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-red-500 hover:bg-red-100 hover:text-gray-400"
            onClick={() => setVerPDF(true)}
          >
            Ver PDF
          </button> */}
        </div>
      </div>
      {/*PDF*/}
      {/* {verPDF ? (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
                          flex flex-col justify-center items-center"
        >
          <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
            <button
              className="text-black font-bold hover:text-white"
              onClick={() => setVerPDF(false)}
            >
              Cerrar
            </button>
          </div>
          <div>
            <DocumentoPDF />
          </div>
        </div>
      ) : null} */}

      {/* Modales */}

      {artRepetido && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-300 font-semibold p-4 rounded">
            <div>Articulo Repetido</div>
            <button
              className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black"
              onClick={() => setArtRepetido(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {clienteError && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-300 font-semibold p-4 rounded">
            <div>
              "Nombre, Ciudad, Direccion, Zona y Telefono son campos
              obligatorios"
            </div>
            <button
              className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black"
              onClick={() => setClienteError(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {articuloError && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gray-300 font-semibold p-4 rounded">
            <div>"Es necesario que introduzca un articulo"</div>
            <button
              className="bg-blue-700 text-white mt-2 p-2 rounded hover:text-black"
              onClick={() => setArticuloError(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
